import { render, staticRenderFns } from "./DashboardViewControl.vue?vue&type=template&id=8c951010"
import script from "./DashboardViewControl.vue?vue&type=script&lang=js"
export * from "./DashboardViewControl.vue?vue&type=script&lang=js"
import style0 from "./DashboardViewControl.vue?vue&type=style&index=0&id=8c951010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports